import { Banknote } from 'lucide-react';
import FinancialKpiSummary from './finance/FinancialKpiSummary';
import TripExpenseTable from './finance/TripExpenseTable';
import { computeTripTableTotals, TRIP_EXPENSES } from './finance/mockFinanceData';

export default function FinanceCostingEngine() {
  const tripTotals = computeTripTableTotals(TRIP_EXPENSES);

  return (
    <section aria-label="Finance and costing engine" className="space-y-5">
      <div className="flex flex-wrap items-end justify-between gap-3 border-b border-logi-grid pb-4">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-emerald-50 ring-1 ring-emerald-500/30">
              <Banknote className="h-4 w-4 text-emerald-700" strokeWidth={1.75} />
            </div>
            <span className="text-xs font-semibold uppercase tracking-widest text-emerald-700/80">
              OGTS LogiCore™ · Commercial Finance Module
            </span>
          </div>
          <h2 className="text-xl font-bold tracking-tight text-logi-text sm:text-2xl">
            Finance &amp; Costing Engine
          </h2>
          <p className="mt-1 text-sm text-logi-muted">
            Trip-level expense breakdown · Fleet profitability · Receivables &amp; invoice tracking
          </p>
        </div>
        <div className="rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-2 text-center">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-logi-text0">
            Portfolio Net Margin
          </p>
          <p className="font-mono text-xl font-bold text-emerald-700">{tripTotals.netMarginPct}%</p>
        </div>
      </div>

      <FinancialKpiSummary />
      <TripExpenseTable />
    </section>
  );
}
